import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useRef, useState } from "react";
import { OrganizationType } from "types/enum";
import { trans } from "utils/helpers";
import { getCityDictionary } from "../api";
interface CustomerPositionPropsType {
  label: string,
  hasBorder?: boolean,
  resetForm: boolean,
  required?: boolean,
  value?: string,
  mode?: string,
  name: string,
  Change?: (e) => void,
  onChange?: (e) => void,
  provinceId?:string,
}

export const CityDictionary = ({ label, provinceId, hasBorder, value, mode ,resetForm,required , name="", Change ,onChange}: CustomerPositionPropsType) => {
  const [city, setCity] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat , setValidat] = useState(false);
  const [count,setCount] = useState<number>(0);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const cityRef = useRef<any>(city);
  const validRef = useRef<any>(false);
  const countRef = useRef<any>(0)

  let optionList : any =[]
  async function getCityDictionaryAsync( id?,provinceId?, search?) {
    try {
    const res = await getCityDictionary(id,provinceId,search);
    if(Object.keys(res.Data).length>0){
      if (id) {
        setValeu(res.Data[id] , id)
        setValueName(res.Data[id])
        onChange && onChange({Name:res.Data[id] , Id : id})
      }

    }else{
      onChange && onChange(null)
    }
    setCity(res.Data)     
    cityRef.current = res.Data
    setFlag(!flag)
  } catch (err: any) {
    onChange && onChange(null)

    }

  }

  const Auto = (e) => {
    validRef.current = false
    setValidat(false)
    setShow(true)
    getCityDictionaryAsync(e.target.value,provinceId,"")
    setFlag(!flag)

  }

  function userSelecter(){
    setValeu(optionList[countRef.current],Object.keys(city)[countRef.current])
    setShow(false)
  }

  const kydown = (event) => {    
    if((event.key === "ArrowDown")){
      if(countRef.current < optionList.length-1){
        countRef.current = countRef.current + 1;
      }else{
        countRef.current = 0;
      }
    }
    
    if(event.key === "ArrowUp"){
      if(countRef.current > 0){
        countRef.current = countRef.current -1;
      }else{
        countRef.current = optionList.length-1;
      }
    }
    document.getElementById("cityDictionary"+countRef.current)?.scrollIntoView({behavior:"smooth"})
    setCount(countRef.current)

    if(event.key === "Enter"){
      userSelecter()
    }
  }
  const CheckCity =async (e)=>{
    
    setTimeout(() => {
       
      if(!validRef.current){
        
        if(city!=undefined &&  Object.values(city).length == 1){
          setValeu(Object.values(city)[0] , Object.keys(city)[0])
          e.target.setCustomValidity("");
        }else{
          if(inputRef?.current){
          setValeu(null,null)
          }
          
          if(inputRef?.current?.value.length >0 && inputRef?.current?.value!=""){
            e.target.setCustomValidity(trans("Msg_Validation_ValueIsIncorrect"));
            setValidat(true);
            e.target.reportValidity();
          }
          setCity(null);
          
        }
      }
    }, 200);
    await delay(200)
    if(!document.activeElement?.className.includes("")){
      setShow(false)
   }
  }
  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));




  const setValeu = (newValue, id) => {
    if(inputIdRef != null && inputIdRef.current != null && newValue){
      validRef.current = true
      inputRef.current.value = newValue
      inputIdRef.current.value = id
      cityRef.current = null;
      ((value==null &&id)|| id != value) ? Change&&Change({[name] :id}):Change&&Change({[name]:null});
      onChange && onChange({Name:newValue , Id : id})
      setCity(null)
      setFlag(!flag)
      setCity({[inputIdRef.current.value]:inputRef.current.value})
      setValidat(false)
    }
  }
  useEffect(() => {
    if(value){
      getCityDictionaryAsync(value,provinceId,null)
    }else if(value == null){
      setValueName(null)

     }
  }, [value,resetForm]);

 useEffect(()=>{
   if(!provinceId){
  }
     inputRef.current.value = null
     inputIdRef.current.value = null
 },[provinceId])

  useEffect(() =>{
    if(show ){
      document.addEventListener('keydown', kydown);
      document.body.addEventListener("click", clickToclose)

    } 
     return () => { document.removeEventListener("keydown", kydown);document.body.removeEventListener('click', clickToclose) }

    
  },[show ,optionList])

  
  function clickToclose(e){
    let input = document.querySelector("#browser"+name);
    if (e.target.id !== input?.id) { 
      setShow(false);
    }
  }



  if(city){
    optionList = Object.values(city)
  }
  return (
    <>
    <div className="text-box">

    <label htmlFor={`browser${name}`} className="text-box__label">{trans(label)}</label>
    {required && <span className="text-box__required-sign-for-label text-danger">*</span>}
    <input required={required} defaultValue={value && value} name={name} className="d-none" ref={inputIdRef} />
    <input  required={required} onBlur={CheckCity} defaultValue={valueName} autoComplete="off" onFocus={(e)=>{  setShow(true);Auto(e)}}  ref={inputRef} list="CityDictionary" name="browser" className="text-box__box form-control " type={'text'}    id={"browser"+name} onMouseDown={(e)=>e.stopPropagation() } onChange={Auto} disabled={mode =="view" || provinceId == null ? true : false} />
    {
       show && 
        <div tabIndex={-1} className={`text-box__sub-menu mt-1`} >
          {optionList && optionList.map((item , index)=>{
                 return  <div id={"cityDictionary"+index} className={`${count == index ?"text-box__sub-menu-option-active" : "text-box__sub-menu-option"}`} onClick={()=>{setValeu(item,Object.keys(city)[index])}} key={Object.keys(city)[index]} >{item}</div>
           })}  
        </div>
     }  
      <div className="text-box__msg-wrapper">
       {required && <span className={`${validat ? "show-msg" : "hide-msg"} text-box__required-msg text-danger`}>{trans("Msg_Validation_ValueIsIncorrect")}</span>}
       </div>    
    </div>
    </>
   )
}